/* eslint-disable no-unused-vars */
import React, { useCallback, useMemo } from 'react'
import { Route } from 'react-router-dom'

import MarginAnalysis from './MarginAnalysis'
import MarginAnalysisWhatIF from './MarginAnalysisWhatIF'
import MarginAnalysisEventPlanning from './MarginAnalysisEventPlanning'
import MarginAnalysisSummary from './MarginAnalysisSummary'
import MarginAnalysisCommaOpsTrueUp from './MarginAnalysisCommaOpsTrueup'

import MarginPnodeZone from './importdata/PnodeZone'
import MarginPnodeZoneAEP from './importdata/PnodeZoneAEP'
import MarginPeakDefinition from './importdata/PeakDefinition'
// import HeatCurve from './importdata/HeatCurve'
import HeatCurve2 from './importdata/HeatCurve2'
import DOMHeatCurve from './importdata/dom/DOMHeatCurve'
import DaPriceData from './importdata/DaPrice'
import RTPriceData from './importdata/RtPrice'
import FuelUsage from './importdata/FuelUsage'
import StartupCost from './importdata/StartupCost'
import StartupOm from './importdata/StartupOm'
import OtherCosts from './importdata/OtherCosts'
import RampRate from './importdata/RampRate'
import Constraints from './importdata/Constraints'
import DayAheadAward from './importdata/DayAheadAward'
import FuelCosts from './importdata/FuelCosts'
import DayAheadLMP from './importdata/DayAheadLMP'
import RealTimeLMP from './importdata/RealTimeLMP'
import LMPPromod from './importdata/LMPPromod'
import FuelPromod from './importdata/FuelPromod'
import StarupCredit from './importdata/StartupCredit'
import FuelCostMissing from './importdata/FuelCostMissingData'
import HydroInputs from './importdata/HydroInputs'
import LMOAdjustment from './importdata/LMOAdjustment'
import MakeWholeCredit from './importdata/MakeWholeCredit'
import HourlyCA from './importdata/OaHourly'
import GasPrice from './importdata/GasPrice'
import Forecast from './importdata/Forecast'
import ForecastGenon from './importdata/ForecastGenon'
import CostAdjustment from './importdata/CostAdjustment'
import { hasAccesPermits } from 'core'
import * as ScreenPermissions from 'core/EventActions'

import {
  TalenBidOffer,
  TalenRealtime,
  TalenDayAhead,
  TalenScheduleDetails,
} from './importdata/talen'

import {
  AEPREG_CLIENT,
  AEPUNREG_CLIENT,
  APS_CLIENT,
  DOM_CLIENT,
  GENON_CLIENT,
  SRP_CLIENT,
  WEE_CLIENT,
  PSE_CLIENT,
  CLECO,
  LANYARD_CLIENT,
} from 'client'
import RegulationCredit from './importdata/RegulationCredit'
import { Menu, Icon } from 'antd'
import BidOffer from './importdata/BidOffer'
import { CPS_CLIENT, NRG_CLIENT } from '../client'
import CommonMarginImport from './importdata/CommonMarginImport'
import {
  GENONMarginImportScreens,
  NRGMarginImportScreens,
} from './importdata/screen-info'
import { pathTitleMap } from 'title'
import AncillaryCredits from './importdata/AncillaryCredits'
import LMOAdjustmentEvent from './importdata/LMOAdjustmentEvent'
const SubMenu = Menu.SubMenu

export const MarginAnalysisContainer = ({ actionPermits, envConfig }) => {
  const CLIENT = envConfig.clientId || 'INTEG'

  const hasMarginMainPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.MARGIN_ANALYSIS_ADMIN,
          ScreenPermissions.MARGIN_ANALYSIS_READ,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasMarginSummaryPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MARGIN_ANALYSIS_SUMMARY],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasMarginTrueupPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MARGIN_ANALYSIS_SUMMARY],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasMarginDataPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.MARGIN_ANALYSIS_CORE_WRITE,
          ScreenPermissions.MARGIN_ANALYSIS_CORE_READ,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const pjmImportPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MARGIN_ANALYSIS_PJMIMPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const promodPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MARGIN_ANALYSIS_PROMOD],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const eventPlamnning = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MARGIN_ANALYSIS_EVENT_PLANNER_SCREEN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hasOutageAnalyzer = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.OUTAGE_ANALYZER],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const HeatCurve = useMemo(
    _ => {
      if (
        CLIENT === DOM_CLIENT ||
        CLIENT === WEE_CLIENT ||
        CLIENT === APS_CLIENT ||
        CLIENT === SRP_CLIENT ||
        CLIENT === PSE_CLIENT ||
        [LANYARD_CLIENT, GENON_CLIENT, NRG_CLIENT].includes(CLIENT)
      ) {
        return DOMHeatCurve
      }
      return HeatCurve2
    },
    [CLIENT]
  )

  const FORECASTFINAL = useMemo(
    _ => {
      if ([LANYARD_CLIENT, GENON_CLIENT].includes(CLIENT)) {
        return ForecastGenon
      }
      return Forecast
    },
    [CLIENT]
  )

  return (
    <>
      {hasMarginMainPermission && (
        <React.Fragment>
          <Route exact path="/marginanalysis" component={MarginAnalysis} />
          <Route
            exact
            path="/marginanalysiswhatif"
            component={MarginAnalysisWhatIF}
          />
          {eventPlamnning && (
            <Route
              exact
              path="/marginanalysis-eventplanning"
              component={MarginAnalysisEventPlanning}
            />
          )}
          {(CLIENT === AEPREG_CLIENT || CLIENT === AEPUNREG_CLIENT) && (
            <Route
              exact
              path="/marginanalysispnodezone"
              component={MarginPnodeZoneAEP}
            />
          )}
          {CLIENT !== AEPREG_CLIENT && CLIENT !== AEPUNREG_CLIENT && (
            <Route
              exact
              path="/marginanalysispnodezone"
              component={MarginPnodeZone}
            />
          )}
          <Route
            exact
            path="/marginanalysispeakdefinition"
            component={MarginPeakDefinition}
          />
          {hasMarginSummaryPermission && (
            <Route
              exact
              path="/marginanalysis-causecodesummary"
              component={MarginAnalysisSummary}
            />
          )}

          {hasMarginTrueupPermission && (
            <Route
              exact
              path="/marginanalysis-trueup"
              component={MarginAnalysisCommaOpsTrueUp}
            />
          )}

          {/* {CLIENT === NRG_CLIENT && (
            <>
              <Route
                exact
                path="/marginanalysis-causecodesummary"
                component={MarginAnalysisSummary}
              />
              <Route
                exact
                path="/marginanalysis-trueup"
                component={MarginAnalysisCommaOpsTrueUp}
              />
            </>
          )} */}
        </React.Fragment>
      )}

      {(hasOutageAnalyzer ||
        hasMarginMainPermission ||
        hasMarginDataPermission) && (
        <React.Fragment>
          <Route
            exact
            path="/marginanalysis-dayaheadlmp-talen"
            component={TalenDayAhead}
          />
          <Route
            exact
            path="/marginanalysis-realtimelmp-talen"
            component={TalenRealtime}
          />
          <Route exact path="/oa-bid-offer-talen" component={TalenBidOffer} />
          <Route
            exact
            path="/oa-schedule-details-talen"
            component={TalenScheduleDetails}
          />
        </React.Fragment>
      )}

      {(hasMarginMainPermission || hasMarginDataPermission) && (
        <React.Fragment>
          <Route exact path="/ma-bid-offer" component={BidOffer} />
          <Route
            exact
            path="/marginanalysis-costadjustment"
            component={CostAdjustment}
          />
          <Route exact path="/marginanalysis-hourlyca" component={HourlyCA} />
          <Route exact path="/marginanalysis-gasprice" component={GasPrice} />
          <Route
            exact
            path="/marginanalysis-forecastdata"
            component={FORECASTFINAL}
          />
          <Route
            exact
            path="/marginanalysis-rt-price"
            component={RTPriceData}
          />
          <Route
            exact
            path="/marginanalysis-da-price"
            component={DaPriceData}
          />
          <Route exact path="/marginanalysis-heatcurve" component={HeatCurve} />

          <Route exact path="/marginanalysis-fuelusage" component={FuelUsage} />

          <Route exact path="/marginanalysis-fuelcosts" component={FuelCosts} />

          <Route
            exact
            path="/marginanalysis-startupheat"
            component={StartupCost}
          />

          <Route exact path="/marginanalysis-startupom" component={StartupOm} />

          <Route
            exact
            path="/marginanalysis-othercosts"
            component={OtherCosts}
          />

          <Route
            exact
            path="/marginanalysis-constraints"
            component={Constraints}
          />

          <Route exact path="/marginanalysis-ramprate" component={RampRate} />

          <Route
            exact
            path="/marginanalysis-dayaheadaward"
            component={DayAheadAward}
          />

          <Route
            exact
            path="/marginanalysis-startupcredit"
            component={StarupCredit}
          />

          <Route
            exact
            path="/marginanalysis-fuelcost-missing"
            component={FuelCostMissing}
          />
          <Route
            exact
            path="/marginanalysis-hydroinput"
            component={HydroInputs}
          />

          <Route
            exact
            path="/marginanalysis-lmoadjustment"
            component={LMOAdjustment}
          />

          <Route
            exact
            path="/marginanalysis-lmoadjustment-event"
            component={LMOAdjustmentEvent}
          />

          <Route
            exact
            path="/marginanalysis-makewholecredit"
            component={MakeWholeCredit}
          />
          <Route
            exact
            path="/marginanalysis-regulationcredit"
            component={RegulationCredit}
          />

          <Route
            exact
            path="/marginanalysis-ancillary-credit"
            component={AncillaryCredits}
          />

          {NRGMarginImportScreens.map(id => (
            <Route
              key={id}
              exact
              path={'/' + id}
              component={CommonMarginImport}
            />
          ))}

          {GENONMarginImportScreens.map(id => (
            <Route
              key={id}
              exact
              path={'/' + id}
              component={CommonMarginImport}
            />
          ))}

          {promodPermission && (
            <React.Fragment>
              <Route
                exact
                path="/marginanalysis-lmppromod"
                component={LMPPromod}
              />
              <Route
                exact
                path="/marginanalysis-fuelpromod"
                component={FuelPromod}
              />
            </React.Fragment>
          )}

          {pjmImportPermission && (
            <React.Fragment>
              <Route
                exact
                path="/marginanalysis-dayaheadlmp"
                component={DayAheadLMP}
              />
              <Route
                exact
                path="/marginanalysis-realtimelmp"
                component={RealTimeLMP}
              />
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </>
  )
}

export const MarginAnalysisMenu = ({
  actionPermits,
  envConfig,
  mode,
  onSelect,
  theme,
  selectedKeys,
}) => {
  const CLIENT = envConfig.clientId

  const marginAnalysisAdminPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.MARGIN_ANALYSIS_ADMIN,
          ScreenPermissions.MARGIN_ANALYSIS_READ,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const marginAnalysisDataPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.MARGIN_ANALYSIS_CORE_WRITE,
          ScreenPermissions.MARGIN_ANALYSIS_CORE_READ,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  // if (CLIENT === SRP_CLIENT) {
  //   return (
  //     <Menu
  //       mode="vertical"
  //       onSelect={onSelect}
  //       theme={theme}
  //       selectedKeys={selectedKeys}
  //     >
  //       (marginAnalysisAdminPermission || marginAnalysisDataPermission) && (
  //       <SubMenu title="Margin Analysis Data">
  //         <Menu.Item key="marginanalysis-heatcurve">Heat Curve</Menu.Item>
  //         <Menu.Item key="marginanalysis-fuelusage">Fuel Usage</Menu.Item>
  //         <Menu.Item key="marginanalysis-fuelcosts">Fuel Costs</Menu.Item>
  //         <Menu.Item key="marginanalysis-startupheat">Startup Cost</Menu.Item>
  //         {/* <Menu.Item key="marginanalysis-startupom">Startup O&M</Menu.Item> */}
  //         <Menu.Item key="marginanalysis-othercosts">Other Costs</Menu.Item>
  //         <Menu.Item key="marginanalysis-constraints">Constraints</Menu.Item>
  //         <Menu.Item key="marginanalysis-da-price">Price Data</Menu.Item>
  //         {/* <Menu.Item key="marginanalysis-rt-price">RT Price Data</Menu.Item> */}
  //         <Menu.Item key="marginanalysis-hydroinput">Hydro Input</Menu.Item>
  //       </SubMenu>
  //       )
  //     </Menu>
  //   )
  // }

  return (
    <Menu
      mode="vertical"
      onSelect={onSelect}
      theme={theme}
      selectedKeys={selectedKeys}
    >
      {CLIENT === APS_CLIENT &&
        (marginAnalysisAdminPermission || marginAnalysisDataPermission) && (
          <SubMenu title="Margin Analysis Data">
            <Menu.Item key="marginanalysis-constraints">Constraints</Menu.Item>
            <Menu.Item key="marginanalysis-costadjustment">
              Cost Adjustment
            </Menu.Item>
            <Menu.Item key="marginanalysis-gasprice">GAS Price</Menu.Item>
            <Menu.Item key="marginanalysis-hourlyca">Hourly CA</Menu.Item>
            <Menu.Item key="marginanalysis-forecastdata">
              Forecast Data
            </Menu.Item>
            <Menu.Item key="marginanalysis-fuelcosts">Fuel Costs</Menu.Item>
            <Menu.Item key="marginanalysis-fuelusage">Fuel Usage</Menu.Item>
            <Menu.Item key="marginanalysis-heatcurve">Heat Curve</Menu.Item>
            <Menu.Item key="marginanalysis-hydroinput">Hydro Input</Menu.Item>
            <Menu.Item key="marginanalysis-othercosts">Other Costs</Menu.Item>
            <Menu.Item key="marginanalysis-rt-price">Price Data</Menu.Item>
            <Menu.Item key="marginanalysis-startupheat">Startup Cost</Menu.Item>
          </SubMenu>
        )}

      {CLIENT === SRP_CLIENT &&
        (marginAnalysisAdminPermission || marginAnalysisDataPermission) && (
          <SubMenu title="Margin Analysis Data">
            <Menu.Item key="marginanalysis-heatcurve">Heat Curve</Menu.Item>
            <Menu.Item key="marginanalysis-fuelusage">Fuel Usage</Menu.Item>
            <Menu.Item key="marginanalysis-fuelcosts">Fuel Costs</Menu.Item>
            <Menu.Item key="marginanalysis-startupheat">Startup Cost</Menu.Item>
            {/* <Menu.Item key="marginanalysis-startupom">Startup O&M</Menu.Item> */}
            <Menu.Item key="marginanalysis-othercosts">Other Costs</Menu.Item>
            <Menu.Item key="marginanalysis-constraints">Constraints</Menu.Item>
            {/* <Menu.Item key="marginanalysis-da-price">Price Data</Menu.Item> */}
            <Menu.Item key="marginanalysis-rt-price">Price Data</Menu.Item>
            <Menu.Item key="marginanalysis-hydroinput">Hydro Input</Menu.Item>
            {/* <Menu.Item key="marginanalysis-lmoadjustment">
              LMO Adjustment
            </Menu.Item>
            <Menu.Item key="marginanalysis-makewholecredit">
              Make Whole Credit
            </Menu.Item>
            <Menu.Item key="marginanalysis-regulationcredit">
              Regulation Credit
            </Menu.Item>
            <Menu.Item key="marginanalysis-startupcredit">
              Startup Credit
            </Menu.Item>
            <Menu.Item key="marginanalysis-dayaheadaward">
              DA Ahead Award
            </Menu.Item>
            <Menu.Item key="marginanalysis-fuelcost-missing">
              Fuel Cost Missing
            </Menu.Item>
            <Menu.Item key="marginanalysis-lmppromod">LMP Promod</Menu.Item>
            <Menu.Item key="marginanalysis-fuelpromod">
              Fuel Price Promod
            </Menu.Item> */}
          </SubMenu>
        )}

      {CLIENT === DOM_CLIENT &&
        (marginAnalysisAdminPermission || marginAnalysisDataPermission) && (
          <SubMenu title="Margin Analysis Data">
            <Menu.Item key="marginanalysis-heatcurve">Heat Curve</Menu.Item>
            <Menu.Item key="marginanalysis-fuelusage">Fuel Usage</Menu.Item>
            <Menu.Item key="marginanalysis-fuelcosts">Fuel Costs</Menu.Item>
            <Menu.Item key="marginanalysis-startupheat">
              Startup Heat Cost
            </Menu.Item>
            {/* <Menu.Item key="marginanalysis-startupom">Startup O&M</Menu.Item> */}
            <Menu.Item key="marginanalysis-othercosts">Other Costs</Menu.Item>
            <Menu.Item key="marginanalysis-constraints">Constraints</Menu.Item>
            <Menu.Item key="marginanalysis-da-price">DA Price Data</Menu.Item>
            <Menu.Item key="marginanalysis-rt-price">RT Price Data</Menu.Item>
            <Menu.Item key="marginanalysis-hydroinput">Hydro Input</Menu.Item>
            <Menu.Item key="marginanalysis-lmoadjustment">
              LMO Adjustment
            </Menu.Item>
            <Menu.Item key="marginanalysis-makewholecredit">
              Make Whole Credit
            </Menu.Item>
            <Menu.Item key="marginanalysis-regulationcredit">
              Regulation Credit
            </Menu.Item>
            <Menu.Item key="marginanalysis-startupcredit">
              Startup Credit
            </Menu.Item>
            <Menu.Item key="marginanalysis-dayaheadaward">
              DA Ahead Award
            </Menu.Item>
            <Menu.Item key="marginanalysis-fuelcost-missing">
              Fuel Cost Missing
            </Menu.Item>
            <Menu.Item key="marginanalysis-lmppromod">LMP Promod</Menu.Item>
            <Menu.Item key="marginanalysis-fuelpromod">
              Fuel Price Promod
            </Menu.Item>
          </SubMenu>
        )}
      {(CLIENT === AEPREG_CLIENT || CLIENT === AEPUNREG_CLIENT) &&
        (marginAnalysisAdminPermission || marginAnalysisDataPermission) && (
          <SubMenu title="Margin Analysis Data">
            <Menu.Item key="ma-bid-offer">Bid Offer</Menu.Item>
            <Menu.Item key="marginanalysis-constraints">Constraints</Menu.Item>
            <Menu.Item key="marginanalysis-fuelcosts">Fuel Costs</Menu.Item>
            <Menu.Item key="marginanalysis-fuelusage">Fuel Usage</Menu.Item>
            <Menu.Item key="marginanalysis-heatcurve">Heat Curve</Menu.Item>
            <Menu.Item key="marginanalysis-hydroinput">Hydro Input</Menu.Item>
            <Menu.Item key="marginanalysis-othercosts">Other Costs</Menu.Item>
            <Menu.Item key="marginanalysis-dayaheadaward">
              Day Ahead Award
            </Menu.Item>
            <Menu.Item key="marginanalysis-da-price">DA Price Data</Menu.Item>
            <Menu.Item key="marginanalysis-rt-price">RT Price Data</Menu.Item>
            <Menu.Item key="marginanalysis-startupheat">
              Startup Heat Cost
            </Menu.Item>
            <Menu.Item key="marginanalysis-startupom">Startup O&M</Menu.Item>
            <Menu.Item key="marginanalysis-ramprate">Ramp Rate</Menu.Item>
          </SubMenu>
        )}
      {CLIENT === PSE_CLIENT &&
        (marginAnalysisAdminPermission || marginAnalysisDataPermission) && (
          <SubMenu title="Margin Analysis Data">
            <Menu.Item key="marginanalysis-heatcurve">Heat Curve</Menu.Item>
            <Menu.Item key="marginanalysis-fuelusage">Fuel Usage</Menu.Item>
            <Menu.Item key="marginanalysis-fuelcosts">Fuel Costs</Menu.Item>
            <Menu.Item key="marginanalysis-startupheat">Startup Cost</Menu.Item>
            <Menu.Item key="marginanalysis-othercosts">Other Costs</Menu.Item>
            <Menu.Item key="marginanalysis-constraints">Constraints</Menu.Item>
            {/* <Menu.Item key="marginanalysis-da-price">DA Price Data</Menu.Item> */}
            <Menu.Item key="marginanalysis-rt-price">RT Price Data</Menu.Item>
          </SubMenu>
        )}

      {CLIENT === NRG_CLIENT &&
        (marginAnalysisAdminPermission || marginAnalysisDataPermission) && [
          <SubMenu title="Margin Analysis Data" key="ma1">
            <Menu.Item key="marginanalysis-heatcurve">Heat Curve</Menu.Item>
            <Menu.Item key="marginanalysis-fuelcosts">Fuel Costs</Menu.Item>
            <Menu.Item key="marginanalysis-fuelusage">Fuel Usage</Menu.Item>
            <Menu.Item key="marginanalysis-startupheat">
              Startup Costs
            </Menu.Item>
            <Menu.Item key="marginanalysis-othercosts">Other Costs</Menu.Item>
            <Menu.Item key="marginanalysis-constraints">Constraints</Menu.Item>
            <Menu.Item key="marginanalysis-rt-price">RT Price Data</Menu.Item>
            <Menu.Item key="marginanalysis-hydroinput">Hydro Input</Menu.Item>
            <Menu.Item key="marginanalysis-lmoadjustment">
              LMO Adjustment
            </Menu.Item>
            <Menu.Item key="marginanalysis-lmoadjustment-event">
              LMO Adjustment Event
            </Menu.Item>
            <Menu.Item key="marginanalysis-makewholecredit">
              Make Whole Credit
            </Menu.Item>
            <Menu.Item key="marginanalysis-regulationcredit">
              Regulation Credit
            </Menu.Item>
            <Menu.Item key="marginanalysis-startupcredit">
              Startup Credit
            </Menu.Item>
            <Menu.Item key="marginanalysis-dayaheadaward">
              DA Ahead Award
            </Menu.Item>
            <Menu.Item key="marginanalysis-fuelcost-missing">
              Fuel Cost Missing
            </Menu.Item>
            <Menu.Item key="marginanalysis-forecastdata">
              Forecast Data
            </Menu.Item>
          </SubMenu>,
          <SubMenu title="Margin Analysis Data (TrueUp)" key="ma2">
            {[...NRGMarginImportScreens, ...GENONMarginImportScreens].map(s => (
              <Menu.Item key={s}>{pathTitleMap[s]}</Menu.Item>
            ))}
          </SubMenu>,
        ]}
      {(CLIENT === GENON_CLIENT || CLIENT === LANYARD_CLIENT) &&
        (marginAnalysisAdminPermission || marginAnalysisDataPermission) && [
          <SubMenu title="Margin Analysis Data" key="ma1">
            <Menu.Item key="marginanalysis-heatcurve">Heat Curve</Menu.Item>
            <Menu.Item key="marginanalysis-fuelcosts">Fuel Costs</Menu.Item>
            <Menu.Item key="marginanalysis-fuelusage">Fuel Usage</Menu.Item>
            <Menu.Item key="marginanalysis-startupheat">Startup Cost</Menu.Item>
            <Menu.Item key="marginanalysis-othercosts">Other Costs</Menu.Item>
            <Menu.Item key="marginanalysis-constraints">Constraints</Menu.Item>
            <Menu.Item key="marginanalysis-rt-price">RT Price Data</Menu.Item>
            <Menu.Item key="marginanalysis-hydroinput">Hydro Input</Menu.Item>
            <Menu.Item key="marginanalysis-lmoadjustment">
              LMO Adjustment
            </Menu.Item>
            <Menu.Item key="marginanalysis-makewholecredit">
              Make Whole Credit
            </Menu.Item>
            <Menu.Item key="marginanalysis-regulationcredit">
              Regulation Credit
            </Menu.Item>
            <Menu.Item key="marginanalysis-startupcredit">
              Startup Credit
            </Menu.Item>
            <Menu.Item key="marginanalysis-dayaheadaward">
              DA Ahead Award
            </Menu.Item>
            <Menu.Item key="marginanalysis-fuelcost-missing">
              Fuel Cost Missing
            </Menu.Item>
            <Menu.Item key="marginanalysis-forecastdata">
              Forecast Data
            </Menu.Item>
          </SubMenu>,
          <SubMenu title="Margin Analysis Data" key="ma2">
            {[...NRGMarginImportScreens, ...GENONMarginImportScreens].map(s => (
              <Menu.Item key={s}>{pathTitleMap[s]}</Menu.Item>
            ))}
          </SubMenu>,
        ]}

      {CLIENT === CLECO &&
        (marginAnalysisAdminPermission || marginAnalysisDataPermission) && (
          <SubMenu title="Margin Analysis Data">
            <Menu.Item key="marginanalysis-fuelusage">Fuel Usage</Menu.Item>
            <Menu.Item key="marginanalysis-startupheat">
              Startup Costs
            </Menu.Item>
            <Menu.Item key="ma-bid-offer">Offer Price</Menu.Item>
            <Menu.Item key="marginanalysis-constraints">Constraints</Menu.Item>
            <Menu.Item key="marginanalysis-da-price">DA Price Data</Menu.Item>
            <Menu.Item key="marginanalysis-rt-price">RT Price Data</Menu.Item>
            <Menu.Item key="marginanalysis-dayaheadaward">
              Day Ahead Award
            </Menu.Item>
            <Menu.Item key="marginanalysis-ramprate">Ramp Rate</Menu.Item>
          </SubMenu>
        )}

      {CLIENT === CPS_CLIENT &&
        (marginAnalysisAdminPermission || marginAnalysisDataPermission) && (
          <SubMenu title="Margin Analysis Data">
            <Menu.Item key="marginanalysis-ancillary-credit">
              Ancillary Credit
            </Menu.Item>
            <Menu.Item key="marginanalysis-constraints">Constraints</Menu.Item>
            <Menu.Item key="marginanalysis-fuelcosts">Fuel Costs</Menu.Item>
            <Menu.Item key="marginanalysis-fuelusage">Fuel Usage</Menu.Item>
            <Menu.Item key="marginanalysis-heatcurve">Heat Curve</Menu.Item>
            <Menu.Item key="marginanalysis-hydroinput">Hydro Input</Menu.Item>
            <Menu.Item key="marginanalysis-othercosts">Other Costs</Menu.Item>
            <Menu.Item key="marginanalysis-dayaheadaward">
              Day Ahead Award
            </Menu.Item>
            <Menu.Item key="marginanalysis-da-price">DA Price Data</Menu.Item>
            <Menu.Item key="marginanalysis-rt-price">RT Price Data</Menu.Item>
            <Menu.Item key="marginanalysis-startupheat">
              {CLIENT === WEE_CLIENT ? 'Startup Heat' : 'Startup Heat Cost'}
            </Menu.Item>
            {CLIENT !== WEE_CLIENT && (
              <Menu.Item key="marginanalysis-startupom">Startup O&M</Menu.Item>
            )}
            <Menu.Item key="marginanalysis-ramprate">Ramp Rate</Menu.Item>
          </SubMenu>
        )}
      {CLIENT !== DOM_CLIENT &&
        CLIENT !== SRP_CLIENT &&
        CLIENT !== APS_CLIENT &&
        CLIENT !== AEPREG_CLIENT &&
        CLIENT !== AEPUNREG_CLIENT &&
        CLIENT !== PSE_CLIENT &&
        CLIENT !== NRG_CLIENT &&
        CLIENT !== CLECO &&
        CLIENT !== GENON_CLIENT &&
        CLIENT !== LANYARD_CLIENT &&
        CLIENT !== CPS_CLIENT &&
        (marginAnalysisAdminPermission || marginAnalysisDataPermission) && (
          <SubMenu title="Margin Analysis Data">
            <Menu.Item key="marginanalysis-constraints">Constraints</Menu.Item>
            <Menu.Item key="marginanalysis-fuelcosts">Fuel Costs</Menu.Item>
            <Menu.Item key="marginanalysis-fuelusage">Fuel Usage</Menu.Item>
            <Menu.Item key="marginanalysis-heatcurve">Heat Curve</Menu.Item>
            <Menu.Item key="marginanalysis-hydroinput">Hydro Input</Menu.Item>
            <Menu.Item key="marginanalysis-othercosts">Other Costs</Menu.Item>
            <Menu.Item key="marginanalysis-dayaheadaward">
              Day Ahead Award
            </Menu.Item>
            <Menu.Item key="marginanalysis-da-price">DA Price Data</Menu.Item>
            <Menu.Item key="marginanalysis-rt-price">RT Price Data</Menu.Item>
            <Menu.Item key="marginanalysis-startupheat">
              {CLIENT === WEE_CLIENT ? 'Startup Heat' : 'Startup Heat Cost'}
            </Menu.Item>
            {CLIENT !== WEE_CLIENT && (
              <Menu.Item key="marginanalysis-startupom">Startup O&M</Menu.Item>
            )}
            <Menu.Item key="marginanalysis-ramprate">Ramp Rate</Menu.Item>
          </SubMenu>
        )}
    </Menu>
  )
}
